import React from 'react';

import BoxConteudo from '../../../../../../components/BoxConteudo';
import CheckBoxList from '../../../../../../components/CheckBoxList';
import CustomOffcanvas from '../../../../../../components/CustomOffcanvas';
import WorkspaceBotoes from '../../../../../../components/WorkspaceBotoes';
import WorkspaceFicha from '../../../../../../components/WorkspaceFicha';

interface OffcanvasTagsProdutoProps {
  show: boolean;
  onClose: () => void;

  tagsProdutos: any[]; // tipar se já houver interface
  selectedTags: any[];
  onTagsChange: (tags: any[]) => void;

  onSave: () => void;
  saveDisabled?: boolean;

  width?: string;
}

const OffcanvasTagsProduto: React.FC<OffcanvasTagsProdutoProps> = ({
  show,
  onClose,
  tagsProdutos,
  selectedTags,
  onTagsChange,
  onSave,
  saveDisabled = false,
  width = '420px',
}) => {
  return (
    <CustomOffcanvas
      show={show}
      onClose={onClose}
      title="Tags do Produto"
      width={width}
      placement="end"
      footerContent={
        <WorkspaceBotoes
          save
          saveDisabled={saveDisabled}
          onClickSave={onSave}
        />
      }
    >
      <WorkspaceFicha>
        <CheckBoxList
          opcoes={tagsProdutos}
          opcoesSelecionadas={selectedTags}
          isOpen={show}
          onChange={onTagsChange}
        />
        {/* </BoxConteudo> */}
      </WorkspaceFicha>
    </CustomOffcanvas>
  );
};

export default OffcanvasTagsProduto;
